import React from 'react';
import getUploadUrl from '../utils/uploadUrl';
import './UserAvatar.css';

const UserAvatar = ({ user, size = 40 }) => {
  const getInitials = (firstName, lastName) => {
    const first = firstName ? firstName.charAt(0).toUpperCase() : '';
    const last = lastName ? lastName.charAt(0).toUpperCase() : '';
    return first + last;
  };

  const firstName = user?.first_name || user?.firstName || '';
  const lastName = user?.last_name || user?.lastName || '';
  const profileImage = user?.profile_image_url || user?.profileImage || null;

  if (profileImage) {
    const imageUrl = getUploadUrl(profileImage);
    
    return (
      <div 
        className="user-avatar"
        style={{ 
          width: `${size}px`, 
          height: `${size}px`,
          borderRadius: '50%',
          overflow: 'hidden',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'var(--color-primary)'
        }}
      >
        <img 
          src={imageUrl} 
          alt={`${firstName} ${lastName}`}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          onError={(e) => {
            // Fallback to initials if image fails to load
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML = getInitials(firstName, lastName);
            e.target.parentElement.style.display = 'flex';
            e.target.parentElement.style.alignItems = 'center';
            e.target.parentElement.style.justifyContent = 'center';
            e.target.parentElement.style.color = 'white';
            e.target.parentElement.style.fontWeight = '600';
          }}
        />
      </div>
    );
  }

  return (
    <div 
      className="user-avatar"
      style={{ 
        width: `${size}px`, 
        height: `${size}px`,
        borderRadius: '50%',
        backgroundColor: 'var(--color-primary)',
        color: 'white',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '600',
        fontSize: `${size * 0.4}px`
      }}
    >
      {getInitials(firstName, lastName)}
    </div>
  );
};

export default UserAvatar;

